import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';
import { PayoutStatus } from './enums/PayoutStatus';

export class PayoutSummary {
  interval: string;

  @Expose({ name: 'total_paid' })
  totalPaid: string;

  @Expose({ name: 'total_pending' })
  totalPending: string;

  @Expose({ name: 'total_balance' })
  totalBalance: string;

  @Expose({ name: 'payout_datewise' })
  payoutDatewise: Record<string, string>;

  @Expose({ name: 'recent_transactions' })
  @Type(() => PayoutTransaction)
  recentTransactions: PayoutTransaction[];

  constructor(
    interval: string,
    totalPaid: string,
    totalPending: string,
    totalBalance: string,
    payoutDatewise: Record<string, string>,
    recentTransactions: PayoutTransaction[]
  ) {
    this.interval = interval;
    this.totalPaid = totalPaid;
    this.totalPending = totalPending;
    this.totalBalance = totalBalance;
    this.payoutDatewise = payoutDatewise;
    this.recentTransactions = recentTransactions;
  }

  static fromJson(json: Record<string, any>): PayoutSummary {
    return plainToInstance(PayoutSummary, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class PayoutTransaction {
  id: number;

  @Expose({ name: 'status_id' })
  status: PayoutStatus;

  total: string;

  fee: string;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  dateCreated: Date;

  constructor(
    id: number,
    status: PayoutStatus,
    total: string,
    fee: string,
    dateCreated: Date
  ) {
    this.id = id;
    this.status = status;
    this.total = total;
    this.fee = fee;
    this.dateCreated = dateCreated;
  }

  static fromJson(json: Record<string, any>): PayoutTransaction {
    return plainToInstance(PayoutTransaction, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
